import { render, staticRenderFns } from "./directorys.vue?vue&type=template&id=292d58c8&scoped=true&"
import script from "./directorys.vue?vue&type=script&lang=js&"
export * from "./directorys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d58c8",
  null
  
)

export default component.exports